import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import { Events, handleAnalytics } from '@foxcorp/delta-web-analytics';
import { refreshPage, redirectToExternalUrl, getExternalSignInUrl } from 'helpers/RouteHelper';
import Style from './FreemiumModalContainer.module.scss';

const FreemiumModalContainer = ({ threshold = 0, onClose = () => {}, redirectUrl = '' }) => {
  const accountCreateSuccess = () => {
    handleAnalytics({
      event: Events.MODAL_CLOSED,
      pyload: {
        page_start_source: 'modal checkout',
        page_plan_flow_type: 'new user acquisition',
        page_item_title: 'x',
        page_action_type: 'close modal',
      },
    });
    if (redirectUrl) {
      redirectToExternalUrl(redirectUrl);
    } else {
      window.setTimeout(refreshPage, 500);
    }
  };
  const { externalFreemiumSignUp } = window.ExternalConfig;

  const src = threshold ? `${externalFreemiumSignUp}?videos=${threshold}` : externalFreemiumSignUp;

  const closeIcon = (
    <Icon onClick={onClose} aria-label="close button" color="white" icon="close" size="large" />
  );

  const handleIframeEvents = e => {
    if (e.data === 'close') {
      onClose();
      accountCreateSuccess();
    }
    if (e.data === '/account/signin') {
      const signInUrl = getExternalSignInUrl();
      redirectToExternalUrl(signInUrl);
    }
  };

  useEffect(() => {
    window.addEventListener('message', handleIframeEvents);
    return () => window.removeEventListener('message', handleIframeEvents);
  });

  return (
    <div className={Style.SignUpModal} onClick={onClose}>
      <div className={Style.IconWrapper} onClick={onClose}>
        {closeIcon}
      </div>
      <iframe title="freemiumModal" src={src} />
    </div>
  );
};

FreemiumModalContainer.propTypes = {
  threshold: PropTypes.number,
  onClose: PropTypes.func,
  redirectUrl: PropTypes.string,
};
export default FreemiumModalContainer;
